// frontend/src/components/Dashboard.js
import React from 'react';
import UploadStatement from './UploadStatement';

export default function Dashboard() {
  const logout = () => { 
    localStorage.removeItem('token'); 
    window.location = '/login'; 
  };

  return (
    <div className="app-shell">
      <div className="bg-particles" id="bgParticles" />
      <FloatingTexts />
      
      <nav className="navbar">
        <div className="navbar-brand">FinTract</div>
        <div className="navbar-actions">
          <button onClick={logout} className="neon-button-secondary">
            Logout
          </button>
        </div>
      </nav>
      
      <div className="container">
        <h1 className="neon-h1">Credit Card Statement Parser</h1>
        <UploadStatement />
      </div>
    </div>
  );
}

// Floating finance-related texts component
function FloatingTexts() {
  const texts = [
    'TRANSACTIONS', 'EXPENSES', 'CREDIT SCORE', 'BALANCE', 
    'STATEMENTS', 'ANALYTICS', 'PAYMENTS', 'SAVINGS',
    'BUDGET', 'INVOICE', 'CASHFLOW', 'INTEREST',
    'MERCHANT', 'DEBIT', 'REVENUE', 'PORTFOLIO'
  ];
  
  return (
    <div className="floating-texts">
      {texts.map((text, index) => (
        <div
          key={index}
          className="float-text"
          style={{
            left: `${Math.random() * 90}%`,
            animationDelay: `${Math.random() * 20}s`,
            animationDuration: `${15 + Math.random() * 10}s`
          }}
        >
          {text}
        </div>
      ))}
    </div>
  );
}